module.exports = __webpack_public_path__ + "img/support-ticket-app.675e88dd.jpg";